import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const insuranceTypes = [
  "Seguro Auto", "Seguro Auto Premium", "Seguro Vida", "Seguro Empresarial",
  "Seguro Vida Empresarial", "Seguro Auto Frota", "Seguro Transporte de Cargas",
  "Seguro Caminhão", "Seguro Empresa Essencial",
  "Responsabilidade Civil Profissional", "Responsabilidade Civil Geral",
  "Seguro RC Adm. e Diretores (D&O)", "Seguro Garantia",
  "Seguro Riscos Cibernéticos", "Seguro Máquinas e Equipamentos",
  "Seguro Condomínio", "Seguro Imobiliária", "Seguro Residencial",
  "Seguro Agronegócio", "Previdência", "Consórcios", "Capital de Giro",
  "Financiamentos", "Empréstimo", "Seguro Moto", "Seguro Táxi",
  "Seguro Fiança", "Proteção Combinada", "Seguro Eventos", "Seguro Mudança",
  "Seguro Carta Verde", "Seguro Carta Azul", "Seguro Viagem",
  "Seguro Equipamentos Portáteis", "Seguro Foto e Vídeo",
  "Seguro Smart e Games", "Seguro Notebook e Tablet", "Seguro Celular",
  "Seguro Bike", "Cartão de Crédito", "Outro",
];

export default function QuoteForm({ preselect = "", compact = false }) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", email: "", insurance_type: preselect, message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.email || !form.insurance_type) {
      toast.error("Preencha todos os campos obrigatórios.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/quotes`, form);
      const msg = [
        `*Nova Solicitação de Cotação*`,
        ``,
        `*Nome:* ${form.name}`,
        `*Telefone:* ${form.phone}`,
        `*E-mail:* ${form.email}`,
        `*Tipo de Seguro:* ${form.insurance_type}`,
        form.message ? `*Mensagem:* ${form.message}` : "",
      ].filter(Boolean).join("\n");
      const waUrl = `https://wa.me/553125550207?text=${encodeURIComponent(msg)}`;
      const a = document.createElement("a");
      a.href = waUrl;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      toast.success("Cotação solicitada! Abrindo WhatsApp...");
      // Google Ads conversion tracking
      if (window.gtag) {
        window.gtag('event', 'conversion', { send_to: 'AW-9363810582/quote_lead' });
        window.gtag('event', 'conversion', { send_to: 'AW-18025861296/quote_lead' });
      }
      // Meta Pixel Lead tracking
      if (window.fbq) window.fbq('track', 'Lead', { content_name: form.insurance_type });
      setForm({ name: "", phone: "", email: "", insurance_type: preselect, message: "" });
    } catch {
      toast.error("Erro ao enviar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`space-y-4 ${compact ? "" : "max-w-xl"}`} data-testid="quote-form">
      <div className={compact ? "space-y-3" : "grid sm:grid-cols-2 gap-4"}>
        <Input placeholder="Nome completo *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-11 bg-white" data-testid="quote-name" />
        <Input placeholder="Telefone *" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="h-11 bg-white" data-testid="quote-phone" />
      </div>
      <Input type="email" placeholder="E-mail *" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="h-11 bg-white" data-testid="quote-email" />
      <Select value={form.insurance_type} onValueChange={(v) => setForm({ ...form, insurance_type: v })}>
        <SelectTrigger className="h-11 bg-white" data-testid="quote-type-select">
          <SelectValue placeholder="Tipo de seguro *" />
        </SelectTrigger>
        <SelectContent>
          {insuranceTypes.map((t) => (
            <SelectItem key={t} value={t}>{t}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!compact && (
        <Textarea placeholder="Mensagem (opcional)" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="min-h-[80px] bg-white" data-testid="quote-message" />
      )}
      <Button type="submit" disabled={loading} className="btn-gold w-full h-12 text-base" data-testid="quote-submit">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Send className="h-4 w-4 mr-2" /> Receber Cotação</>}
      </Button>
    </form>
  );
}
